import { Icon, Text, WrapItem, WrapItemProps } from "@chakra-ui/react";
import { RiCheckboxCircleLine, RiCloseCircleLine } from "@remixicon/react";

interface Props extends WrapItemProps {
  title: string;
  isComplete?: boolean;
}

export const ProfileCompleteCard = ({
  title,
  isComplete = false,
  ...rest
}: Props) => {
  return (
    <WrapItem
      color={isComplete === true ? "teal.400" : "gray.400"}
      gap={1}
      {...rest}
    >
      <Icon
        as={isComplete === true ? RiCheckboxCircleLine : RiCloseCircleLine}
        fontWeight={isComplete === true ? "semibold" : "normal"}
        fontSize={[16, null, 18]}
      />
      <Text
        textStyle={"b-reg"}
        fontWeight={isComplete === true ? "semibold" : "normal"}
      >
        {title}
      </Text>
    </WrapItem>
  );
};
